import { BrowserRouter, Routes, Route, Link, useNavigate, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AdminDashboard from './components/admin/AdminDashboard';
import KioskApp from './components/kiosk/KioskApp';
import CounterApp from './components/counter/CounterApp';
import DisplayApp from './components/display/DisplayApp';
import Login from './components/shared/Login';
import { Setup } from './components/shared/Setup';
import { Spinner } from './components/shared/UI';
import './index.css';

function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center', background: 'var(--navy)' }}><Spinner /></div>;
  if (!user) return <Navigate to="/login" />;
  if (role && user.role !== role) return <Navigate to="/" />;
  return children;
}

function Home() {
  const nav = useNavigate();
  const { logout, user } = useAuth();
  const modules = [
    { path: '/admin', label: 'Admin Dashboard', icon: '◈', desc: 'Manage counters, services, mapping, media & reports', color: 'var(--navy)', accent: 'var(--cobalt-bright)' },
    { path: '/kiosk', label: 'Shop', icon: '⊡', desc: 'Customer self-service ticket issuance terminal', color: 'var(--cobalt)', accent: '#fff' },
    { path: '/counter', label: 'Counter', icon: '⊞', desc: 'Agent interface for queue & service management', color: '#1b5e20', accent: '#a5d6a7' },
    { path: '/display', label: 'Display Screen', icon: '▷', desc: 'Public digital signage with now-serving & media', color: '#311b92', accent: '#b39ddb' },
  ];

  return (
    <div className="home-container" style={{ minHeight: '100vh', background: 'var(--navy)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 40 }}>
      <div className="home-user" style={{ position: 'absolute', top: 32, right: 40, display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
        {user ? (
          <>
            <span style={{ color: '#fff', fontSize: 14 }}>Logged in as <strong>{user.username}</strong></span>
            <button onClick={logout} style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: '#fff', padding: '6px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>Logout</button>
          </>
        ) : (
          <Link to="/login" style={{ color: 'var(--cobalt-bright)', textDecoration: 'none', fontWeight: 600, fontSize: 14 }}>Sign In</Link>
        )}
      </div>
      
      <div style={{ textAlign: 'center', marginBottom: 56 }}>
        <div className="home-title" style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 56, color: '#fff', letterSpacing: '-0.04em', lineHeight: 1 }}>QMS</div>
        <div style={{ fontSize: 18, color: 'rgba(255,255,255,0.5)', marginTop: 10, fontWeight: 300 }}>Queue Management System</div>
      </div>

      <div className="resp-grid-2" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 20, width: '100%', maxWidth: 820 }}>
        {modules.map(m => (
          <button key={m.path} onClick={() => nav(m.path)} className="home-module-btn"
            style={{
              padding: '36px 32px', borderRadius: 20, border: '1.5px solid rgba(255,255,255,0.1)',
              background: m.color, cursor: 'pointer', textAlign: 'left', transition: 'all 0.2s',
              boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 16px 48px rgba(0,0,0,0.5)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.4)'; }}>
            <div style={{ fontSize: 36, marginBottom: 14, color: m.accent }}>{m.icon}</div>
            <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 22, color: '#fff', marginBottom: 8 }}>{m.label}</div>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', lineHeight: 1.5 }}>{m.desc}</div>
            <div style={{ marginTop: 20, fontSize: 13, color: m.accent, fontFamily: 'var(--font-display)', fontWeight: 600 }}>Open → </div>
          </button>
        ))}
      </div>


    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login onLoginSuccess={() => window.history.back()} />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/admin/*" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/kiosk" element={<KioskApp />} />
          <Route path="/counter" element={<ProtectedRoute><CounterApp /></ProtectedRoute>} />
          <Route path="/display" element={<DisplayApp />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
